var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "#F0F1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    stroke: "#DFDEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 19C28.0054 19 27.0516 18.6049 26.3483 17.9017C25.6451 17.1984 25.25 16.2446 25.25 15.25V10.25H17.75C16.7554 10.25 15.8016 10.6451 15.0983 11.3483C14.3951 12.0516 14 13.0054 14 14V34C14 34.9946 14.3951 35.9484 15.0983 36.6517C15.8016 37.3549 16.7554 37.75 17.75 37.75H30.25C31.2446 37.75 32.1984 37.3549 32.9017 36.6517C33.6049 35.9484 34 34.9946 34 34V19H29ZM29.0625 26.9125L25.3125 29.4125C25.1112 29.5535 24.8708 29.6278 24.625 29.625C24.4156 29.626 24.2093 29.5745 24.025 29.475C23.8277 29.3671 23.6632 29.2079 23.5488 29.0143C23.4344 28.8207 23.3744 28.5999 23.375 28.375V27.125H19.625C19.2935 27.125 18.9755 26.9933 18.7411 26.7589C18.5067 26.5245 18.375 26.2065 18.375 25.875C18.375 25.5435 18.5067 25.2255 18.7411 24.9911C18.9755 24.7567 19.2935 24.625 19.625 24.625H23.375V23.375C23.3744 23.1501 23.4344 22.9293 23.5488 22.7357C23.6632 22.5421 23.8277 22.3829 24.025 22.275C24.2205 22.1746 24.4389 22.1276 24.6584 22.1385C24.8778 22.1495 25.0905 22.2181 25.275 22.3375L29.025 24.8375C29.1952 24.9518 29.3346 25.1063 29.431 25.2872C29.5274 25.4681 29.5778 25.67 29.5778 25.875C29.5778 26.08 29.5274 26.2819 29.431 26.4628C29.3346 26.6437 29.1952 26.7982 29.025 26.9125H29.0625ZM27.75 15.25V10.3875C28.3796 10.5621 28.9527 10.8982 29.4125 11.3625L32.9125 14.8875C33.3558 15.3375 33.6783 15.8921 33.85 16.5H29C28.6685 16.5 28.3505 16.3683 28.1161 16.1339C27.8817 15.8995 27.75 15.5815 27.75 15.25Z",
    fill: "#585C91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.315d6c94.svg";
export { ForwardRef as ReactComponent };